import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
function NoMatch() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Result
        status="404"
        title="404"
        subTitle="Sorry, the page you visited does not exist."
        extra={
          <Button
            type="primary"
            onClick={() => {
              navigate(-1);
            }}
          >
            Back Home
          </Button>
        }
      />
      ,
    </div>
  );
}

export default NoMatch;
